<template>
  <div class="row pt-3">
    <div class="col-sm-8 float-left text-primary">
      <strong class="text-primary"> Deine Entfernung zu {{ userName }} </strong>
    </div>
    <div class="col-sm-4">
      <label
        v-tooltip:top="
          'Die Entfernung basiert auf der annoymisierten Postleitzahl und ist dem entsprechend ungenau.'
        "
        class="float-sm-right text-success"
        ><strong>{{ parseInt(distance) }} km</strong></label
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    distance: {
      required: true
    },
    userName: {
      required: true,
      type: String
    }
  }
};
</script>
